<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Product Library
      <small class="pull-right title-link">
        <a (click)="showAddProductWindow()" [routerLinkActive]="['active-link']">Design New</a>
        <a [routerLink]="['/store/publishedproducts']">See Published</a>
      </small>
      <span class="clearfix"></span>

      <i *ngIf="mobileScreen" class="fa fa-filter mobile-filter-icon d-md-none" aria-hidden="true" data-toggle="modal"
         data-target="#open-mobile-filter"></i>

    </h5>
    <div class="row">
      <div class="col-md-3 col-sm-4">
        <div class="white-background d-none d-md-block" *ngIf="!mobileScreen">
          <app-filter (getProducts)="updateProductList($event)" [filterModel]="filterModel" [filterList]="filterList"
                      [pageSize]="pageSize" [searchCustomizedForm]="searchCustomizedForm"></app-filter>
        </div>
      </div>
      <div class="col-md-9 col-sm-8">
        <div class="row">
          <div class="col-sm-12">
            <form class="searcProductsCustomized" [formGroup]="searchCustomizedForm">
              <i class="fa fa-search" aria-hidden="true"></i>
              <input class="form-control" placeholder="Search Product Library..." formControlName="searchProduct"
                     ng-model-options="{debounce: 10000}" (change)="fn_searchCustomizeProduct(searchCustomizedForm)">
            </form>
          </div>
        </div>

        <h6 style="display: none;" [ngStyle]="{'display': isDisplay}" class="text-center no-rcrd">
          <img src="assets/img/empty-state3.png" style="width: 50%; margin: 50px; filter: opacity(0.5);" />
          <br />

          No item(s) available
          <span class="design-new-product text-info" (click)="showAddProductWindow()"
                [routerLinkActive]="['active-link']">Design Now</span>
        </h6>

        <div class="search-results" infiniteScroll [infiniteScrollDistance]="scrollDistance"
             [infiniteScrollThrottle]="throttle" (scrolled)="fn_GetSavedDesignListing_Scroll()"
             [infiniteScrollDisabled]="isFullListDisplayed">
          <div class="row">
            <div class="col-sm-6 col-lg-3 ovt-trns-ttl" *ngFor="let product of customizedProducts ;index as i"
                 [ngClass]="{'discontinuedProduct': !product.ProductDescription[0].IsActive}">
              <div class="store-item">
                <div class="store-item-thumb">
                  <div class="cstm-prdct display-table">
                    <div class="display-cell">
                      <i *ngIf="!product.ShopifyProduct && product.IsWarehouseProduct==false"
                         (click)="fn_deleteCustomizedProduct(product)" class="material-icons delete-product"
                         title="Delete Design">
                        delete_outline
                      </i>

                      <span [ngClass]="product.CustomizationType.length <=9 ?'dec-type': 'dec-typeEmb'">
                        {{product?.CustomizationType}} 
                      </span>
                      <img matTooltip="Product from Shopify" *ngIf="product.ShopifyProduct"
                           src="assets/img/shopify-icon.png" width="18" alt="" class="shopify-product">

                      <img *ngIf="product.IsDefaultImageCustom === true"
                           [src]="product.DefaultImage ? imgCustomBaseURL + product.DefaultImage : 'assets/img/no-image-available.jpg'">
                      <img *ngIf="product.IsDefaultImageCustom === false && (product.DefaultImage == '' || product.DefaultImage == null)"
                           [src]="product.PngRelativeUrlWithProduct ? (product.IsWarehouseProduct == false ? imgBaseURL + product.PngRelativeUrlWithProduct :wareHouseImageUrl + product.PngRelativeUrlWithProduct) : 'assets/img/no-image-available.jpg'">
                      <img *ngIf="product.IsDefaultImageCustom === false && (product.DefaultImage != '' && product.DefaultImage != null)"
                           [src]="product.DefaultImage ? (product.IsWarehouseProduct == false ? imgBaseURL + product.DefaultImage : product.DefaultImage) : 'assets/img/no-image-available.jpg'">

                      <img *ngIf="!product.ImgLoaded" src="/assets/img/load-spinner.gif" alt="loading" />
                      <img *ngIf="!product.IsWarehouseProduct"
                           [src]="product.Img || 'assets/img/no-image-available.jpg'" [hidden]="!product.ImgLoaded"
                           (load)="product.ImgLoaded=true">
                      <img *ngIf="product.IsWarehouseProduct"
                           [src]="wareHouseImageUrl + product.PngRelativeUrlWithProduct || 'assets/img/no-image-available.jpg'"
                           [hidden]="!product.ImgLoaded" (load)="product.ImgLoaded=true">


                      <div *ngIf="!product.ShopifyProduct" class="list-lnk">
                        <ul>
                          <li>
                            <a class="adcart" (click)="fn_ProductDetails(product.ProductId,product.DesignId, i, false)">
                              Details
                            </a>
                          </li>
                          <li *ngIf="product.ProductDescription[0].IsActive">
                            <a class="adwscart"
                               (click)="fn_OpenPublishModal(product.CustomizedProductId,product.ProductId, product.IsWarehouseProduct,product.DesignId,product.IsPublished)">
                              Publish
                            </a>
                          </li>
                          <!--<li>
                            <a class="adwscart" (click)="fn_SampleOrder(product.ProductId,product.DesignId)">
                              Sample Order
                            </a>
                          </li>-->
                        </ul>
                      </div>
                      <div *ngIf="product.ShopifyProduct" class="list-lnk">
                        <ul>
                          <li>
                            <a class="adcart" (click)="fn_ProductDetails(product.ProductId,product.DesignId, i,true)">
                              Details
                            </a>
                          </li>
                          <li *ngIf="product.ProductDescription[0].IsActive && product.IsSizingLabelGenerated">
                            <a (click)="editProduct(product.ProductId,product.DesignId, product.StyleId,true)"
                               class="adwscart" style="cursor: pointer;">Redesign</a>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="store-item-cntnt">
                  <small *ngIf="!product.ProductDescription[0].IsActive" class="discontinuedText">
                    ***Discontinued
                  </small>
                  <small *ngIf="product.ProductDescription[0].IsActive &&  product.IsWarehouseProduct == false"
                         class="order-sample-link">
                    <a (click)="fn_SampleOrder(product.ProductId,product.DesignId,false)"
                       *ngIf="!product.ShopifyProduct">
                      Order a Sample
                    </a>
                    <a *ngIf="product.ShopifyProduct">
                      &nbsp;
                    </a>
                  </small>
                  <h4 class="product-title">
                    <i style="vertical-align:middle" class="material-icons text-muted"
                       *ngIf="product.IsWarehouseProduct" title="Warehouse Product">
                      store_mall_directory
                    </i>&nbsp;
                    {{product.Name}}
                  </h4>
                </div>
                <!-- Farbe und GroBe  -->
                <div class="available-sizes store-item-cntnt">
                  <span *ngFor="let sz of product.Sizes">
                    <span> {{sz.Name}}</span>
                  </span>
                </div>
                <div class="color-list store-item-cntnt tick">
                  <!--Conditional based isActive display-->
                  <ng-container *ngFor="let s of product.ColorList">
                    <div title="{{s.ColorName}}" class="available-colors" *ngIf="s.IsActive"
                         [ngStyle]="displayColor( s.ColorHexCode)"
                         [ngClass]="{'selected-style':s.StyleId == product.StyleId}" data-tooltip="s.ColorName"
                         (click)="selectStyleToCustomize(s, i)">
                    </div>
                    <div title="{{s.ColorName}} ***Discontinued" class="available-colors discontinuedColor"
                         *ngIf="!s.IsActive" [ngStyle]="displayColor(s.ColorHexCode)"
                         [ngClass]="{'selected-style':s.StyleId == product.StyleId}" data-tooltip="s.ColorName"
                         (click)="selectStyleToCustomize(s, i)">
                    </div>
                  </ng-container>
                  <small *ngIf="product.ColorList.length == 0" class="text-muted"
                         (click)="fn_ProductDetails(product.ProductId,product.DesignId,true)">
                    View all color
                  </small>
                </div>

              </div>
            </div>
          </div>
          <app-lazy-loader></app-lazy-loader>
        </div>

      </div>
    </div>


    <!-- Modal -->
    <div *ngIf="mobileScreen" class="modal fade" id="open-mobile-filter" tabindex="-1"
         aria-labelledby="open-mobile-filterLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <app-filter (getProducts)="updateProductList($event)" [filterModel]="filterModel" [filterList]="filterList"
                        [pageSize]="pageSize" [searchCustomizedForm]="searchCustomizedForm"></app-filter>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
